export default __webpack_public_path__ + "static/media/long-arrow-right.b48cda71.svg";